import * as React from 'react';
import Button from '../../../Button/Button';
import './ReviewCard.css';
import { LibraryCard } from '../../../../types/LibraryCard';
import ReviewPopup from '../../../ReviewPopup/ReviewPopup';
import { MARK_LABELS, MOBILE_MAX_WIDTH } from '../../../../utils';
import ThumbUp from '@material-ui/icons/ThumbUpAlt';
import { useMediaQuery } from 'react-responsive';

interface Props {
	card: LibraryCard;
}

const ReviewCard: React.FC<Props> = ({ card }) => {
	const [dialogOpen, setDialog] = React.useState(false);

	const closePopup = () => setDialog(false);
	const openPopup = () => setDialog(true);

	const onPublished = () => {
		setTimeout(() => {
			window.location.reload();
		}, 2000);
	};

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	const review = card.review;

	return (
		<div className="reviewCard">
			<div className="reviewCard__header">Мой рейтинг</div>

			{isMobile && review && (
				<Button onClick={openPopup} className="reviewCard__mobile_button">
					Открыть
				</Button>
			)}

			<div className="reviewCard__wrapper">
				<div className="reviewCard__main">
					{review?.isRecommend && (
						<div className="reviewCard__recommend">
							<ThumbUp /> рекомендую к прочтению
						</div>
					)}

					{!review && (
						<div className="reviewCard__subheader">
							поставьте оценку и опишите ваши впечатления от книги
						</div>
					)}

					{(!isMobile || !review) && <Button type={!review ? "primary" : "secondary"} onClick={openPopup}>
						{review?.id ? "Перейти к отзыву" : "Оценить книгу"}
					</Button>}
				</div>

				<div className="reviewCard-mark__wrapper">
					<div className="reviewCard__mark">{review ? review.mark : "--"}</div>

					<div className="reviewCard__markReadable">
						{review?.mark ? MARK_LABELS[review.mark - 1] : "нет оценки"}
					</div>
				</div>
			</div>

			{dialogOpen && (
				<ReviewPopup
					card={card}
					onClose={closePopup}
					onPublished={onPublished}
					review={review}
				/>
			)}
		</div>
	);
};

export default ReviewCard;